( function () {
	'use strict';

	function ScoreValidationCtrl ( $modalInstance, model, groupModel, templateModel, templateLevel ) {
		var self = this;

		function proceedModal () {
			delete model.score;

			if ( templateLevel ) {
				templateModel.formula = '';
			}

			groupModel.formula = '';
			$modalInstance.close();
		}

		function cancelModal () {
			$modalInstance.close();
		}

		self.proceedModal = proceedModal;
		self.cancelModal  = cancelModal;
	}

	angular
		.module( 'app.components' )
		.controller( 'ScoreValidationCtrl', ScoreValidationCtrl );

	ScoreValidationCtrl.$inject = [ '$modalInstance', 'model', 'groupModel', 'templateModel', 'templateLevel' ];
} )( );
